import { render, staticRenderFns } from "./titleYear.vue?vue&type=template&id=a5c751e8&scoped=true"
import script from "./titleYear.vue?vue&type=script&lang=js"
export * from "./titleYear.vue?vue&type=script&lang=js"
import style0 from "./titleYear.vue?vue&type=style&index=0&id=a5c751e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5c751e8",
  null
  
)

export default component.exports